import { createUseStyles } from 'react-jss';

const useStyle = ({ transitionTime }) => createUseStyles((theme) => ({
  collapsibleItem: {
    borderRadius: theme.sizes.radius,
    display: 'block',
    width: '100%',
    border: `1px solid ${theme.colors.lightGray.normal}`,
  },
  shadow: {
    boxShadow: `0 0 5px ${theme.colors.lightGray.dark}`,
    border: 'none',
  },
  title: {
    width: '100%',
    paddingLeft: theme.sizes.base,
    paddingRight: theme.sizes.base,
  },
  summary: {
    cursor: 'pointer',
    listStyle: 'none',
    fontSize: theme.sizes.fontBase,
    fontWeight: 'bold',
    listStyleType: 'none',
    padding: theme.sizes.base * 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  detailsContent: {
    transition: `all ${transitionTime}ms ease`,
    transform: 'translate(0, -100%)',
    boxSizing: 'content-box',
    overflow: 'hidden',
    padding: `0 ${theme.sizes.base * 2}px`,
  },
  contentOpen: {
    transform: 'translate(0,0)',
  },
  detailsWrapper: {
    overflow: 'hidden',
    height: 0,
  },
  detailsWrapperOpen: {
    height: 'auto',
  },
}))();

export default useStyle;
